import { useMemo } from 'react';

function useBackgroundState(layout) {
  const hasSolidBackground = useMemo(() => layout?.surface.background ? hasSolidValue(layout.surface.background) : false, [layout?.surface.background]);
  const hasSolidBorder = useMemo(() => layout?.surface.border ? hasVisibleBorder(layout.borderStyle, layout.borderWidth) && hasSolidValue(layout.surface.border) : false, [layout?.borderStyle, layout?.borderWidth, layout?.surface.border]);
  return {
    hasSolidBackground,
    hasSolidBorder
  };
}
function hasSolidValue(token) {
  const computedStyles = window.getComputedStyle(document.body);
  const alpha = Number(computedStyles.getPropertyValue(token.alpha.propName));
  if (Number.isNaN(alpha) || alpha === 0) {
    return false;
  }
  return true;
}
function hasVisibleBorder(borderStyleToken, borderWidthToken) {
  const computedStyles = window.getComputedStyle(document.body);
  const width = computedStyles.getPropertyValue(borderWidthToken.propName);
  if (width === "0" || width === "0px") {
    return false;
  }
  const style = computedStyles.getPropertyValue(borderStyleToken.propName);
  if (style === "" || style === "none" || style === "hidden") {
    return false;
  }
  return true;
}

export { useBackgroundState };
//# sourceMappingURL=useBackgroundState.js.map
